var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg100S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 17C42.6836 27 57.0498 33 57.0498 44.4C57.0498 45.9913 56.1595 47.5174 54.5746 48.6426C52.9898 49.7679 50.8404 50.4 48.5991 50.4C46.3578 50.4 44.2084 49.7679 42.6236 48.6426C41.0387 47.5174 40.1484 45.9913 40.1484 44.4C40.1484 44.2939 40.089 44.1922 39.9834 44.1172C39.8777 44.0421 39.7344 44 39.585 44C39.4356 44 39.2923 44.0421 39.1866 44.1172C39.081 44.1922 39.0216 44.2939 39.0216 44.4C39.0216 52.4 41.8385 53 44.3737 57H29.7259C32.2611 53 35.078 52.4 35.078 44.4C35.078 44.2939 35.0186 44.1922 34.913 44.1172C34.8073 44.0421 34.664 44 34.5146 44C34.3652 44 34.2219 44.0421 34.1162 44.1172C34.0106 44.1922 33.9512 44.2939 33.9512 44.4C33.9512 45.9913 33.0609 47.5174 31.4761 48.6426C29.8912 49.7679 27.7418 50.4 25.5005 50.4C23.2592 50.4 21.1098 49.7679 19.525 48.6426C17.9401 47.5174 17.0498 45.9913 17.0498 44.4C17.0498 33 31.416 27 37.0498 17Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 168V187.826C155 191.055 153.736 194.151 151.485 196.434C149.235 198.717 146.183 200 143 200C139.817 200 136.765 198.717 134.515 196.434C132.264 194.151 131 191.055 131 187.826V148.174C131 144.945 132.264 141.849 134.515 139.566C136.765 137.283 139.817 136 143 136C146.183 136 149.235 137.283 151.485 139.566C153.736 141.849 155 144.945 155 148.174V168Z",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 168V187.826C117 191.055 115.736 194.151 113.485 196.434C111.235 198.717 108.183 200 105 200C101.817 200 98.7652 198.717 96.5147 196.434C94.2643 194.151 93 191.055 93 187.826V148.174C93 144.945 94.2643 141.849 96.5147 139.566C98.7652 137.283 101.817 136 105 136C108.183 136 111.235 137.283 113.485 139.566C115.736 141.849 117 144.945 117 148.174V168Z",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2 135.027C77.2065 136.121 77.2065 136.121 77.2131 137.237C77.2546 144.111 77.3012 150.984 77.3533 157.858C77.38 161.392 77.4047 164.925 77.425 168.459C77.4447 171.87 77.4694 175.28 77.4976 178.691C77.5075 179.992 77.5156 181.293 77.5218 182.594C77.5308 184.416 77.5463 186.239 77.5633 188.062C77.5704 189.099 77.5775 190.136 77.5848 191.205C77.7299 193.806 77.9058 195.309 78.8 197.434C80.4224 198.586 80.4224 198.586 82 199.217C82 199.805 82 200.394 82 201C76.896 201 71.792 201 66.5333 201C66.5333 200.412 66.5333 199.823 66.5333 199.217C68.9093 198.334 68.9093 198.334 71.3333 197.434C71.358 190.854 71.377 184.275 71.3886 177.695C71.3942 174.64 71.4017 171.585 71.4138 168.53C71.4276 165.018 71.4328 161.506 71.4375 157.994C71.443 156.896 71.4485 155.799 71.4542 154.668C71.4543 153.142 71.4543 153.142 71.4544 151.585C71.4568 150.688 71.4592 149.792 71.4616 148.868C71.428 146.397 71.428 146.397 70.2667 143.942C69.0347 144.236 67.8027 144.531 66.5333 144.834C66.3573 143.951 66.1813 143.068 66 142.159C67.3635 140.959 68.7303 139.773 70.1 138.593C70.4847 138.253 70.8693 137.913 71.2656 137.562C71.642 137.24 72.0184 136.919 72.4063 136.587C72.7498 136.288 73.0933 135.989 73.4473 135.682C74.7473 134.898 75.8272 134.982 77.2 135.027Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2127_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.95 319C181.316 309 166.95 303 166.95 291.6C166.95 290.009 167.841 288.483 169.425 287.357C171.01 286.232 173.16 285.6 175.401 285.6C177.642 285.6 179.792 286.232 181.376 287.357C182.961 288.483 183.852 290.009 183.852 291.6C183.852 291.706 183.911 291.808 184.017 291.883C184.122 291.958 184.266 292 184.415 292C184.564 292 184.708 291.958 184.813 291.883C184.919 291.808 184.978 291.706 184.978 291.6C184.978 283.6 182.161 283 179.626 279H194.274C191.739 283 188.922 283.6 188.922 291.6C188.922 291.706 188.981 291.808 189.087 291.883C189.193 291.958 189.336 292 189.485 292C189.635 292 189.778 291.958 189.884 291.883C189.989 291.808 190.049 291.706 190.049 291.6C190.049 290.009 190.939 288.483 192.524 287.357C194.109 286.232 196.258 285.6 198.499 285.6C200.741 285.6 202.89 286.232 204.475 287.357C206.06 288.483 206.95 290.009 206.95 291.6C206.95 303 192.584 309 186.95 319Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 160 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 122 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 70,
    fill: "white",
    transform: "matrix(-1 0 0 -1 84 203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2127_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100S);
export default __webpack_public_path__ + "static/media/100S.601eeecd74eb164178b384262d228165.svg";
export { ForwardRef as ReactComponent };